import React, { forwardRef, useImperativeHandle, useState } from 'react';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  Tabs,
  Tab,
  Box,
  Typography,
} from '@material-ui/core';

// Componente para conteúdo das abas
function TabPanel({ children, value, index }) {
  return (
    <div hidden={value !== index}>
      {value === index && (
        <Box p={2}>
          <Typography
            style={{ whiteSpace: 'pre-wrap', fontFamily: 'monospace' }}
          >
            {children}
          </Typography>
        </Box>
      )}
    </div>
  );
}

const DialogComAbas = forwardRef(({ onClose = () => {} }, ref) => {
  const [tab, setTab] = useState(0);
  const [open, setOpen] = useState(false);
  const [dados, setDados] = useState({
    retorno: null,
    envio: null,
    inutilizacao: null,
  });

  const handleChange = (event, newValue) => {
    setTab(newValue);
  };

  useImperativeHandle(ref, () => ({
    handleOpen(dados, venda) {
      setOpen(true);
      setDados(dados);
      setTab(0);
    },
  }));

  return (
    <Dialog
      open={open}
      onClose={() => {
        setOpen(false);
      }}
      maxWidth="lg"
      fullWidth
    >
      <DialogTitle>Teste Rejeitada</DialogTitle>

      <Tabs
        value={tab}
        onChange={handleChange}
        indicatorColor="primary"
        textColor="primary"
        centered
      >
        <Tab label="Retorno" />
        <Tab label="Envio" />
        <Tab label="Inutilizacao" />
      </Tabs>

      <DialogContent dividers>
        <TabPanel value={tab} index={0}>
          {dados.retorno}
        </TabPanel>

        <TabPanel value={tab} index={1}>
          {dados.envio}
        </TabPanel>

        <TabPanel value={tab} index={2}>
          {dados.inutilizacao}
        </TabPanel>
      </DialogContent>
    </Dialog>
  );
});

export default DialogComAbas;
